import { useLayoutEffect, useState } from 'react';
import { useStopwatch } from 'react-timer-hook';
import s from './StopWhatch.module.scss';

interface Props {
    doPause: boolean;
    currentId: string;
    getTimePassedCallBack: (time: string) => void;
}
const StopWatch = ({ doPause, currentId, getTimePassedCallBack }: Props) => {
    const { seconds, minutes, hours, days, isRunning, start, pause, reset } =
        useStopwatch({ autoStart: true });

    const [id, setId] = useState<string>();

    if (doPause && isRunning) {
        pause();
        getTimePassedCallBack(`${hours}:${minutes}:${seconds}`);
    }
    // useLayoutEffect(() => {
    //     if (currentId !== id) {
    //         getTimePassedCallBack(`${hours}:${minutes}:${seconds}`);

    //         setId(currentId);
    //         reset();
    //         start();
    //     }
    // }, [currentId]);
    useLayoutEffect(() => {
        getTimePassedCallBack(`${hours}:${minutes}:${seconds}`);
        if (currentId !== id) {
            setId(currentId);
            reset();
            start();
        }
    }, [
        currentId,
        getTimePassedCallBack,
        hours,
        id,
        minutes,
        reset,
        seconds,
        start,
    ]);

    return (
        <div className={s.rt}>
            <div>
                <span>{minutes}</span>:
                <span>{seconds > 9 ? seconds : '0' + seconds}</span>
            </div>
        </div>
    );
};
export default StopWatch;
